export default "__VITE_ASSET__e884ad0b__"